module.exports = __webpack_public_path__ + "static/media/shortflowersglb.75228057.glb";